import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { buildInsideMapsData } from "src/components/molecules/InsideMaps/insideMapsData";
import { InsideMapsIFrameView } from "src/components/molecules/InsideMaps/InsideMapsIFrame";
import { Css } from "~generated/css";
import { useConfigurationRenderingCapturePageQuery } from "./ConfigurationRenderingCapturePage.generated";

// this page loads up the iframe for the rendering with the given location name
export function ConfigurationRenderingCapturePage() {
  const { configId, locationId } = useParams<{ configId: string; locationId: string }>();
  const query = useConfigurationRenderingCapturePageQuery({
    variables: { id: configId ?? "", debugParts: [] },
    skip: !configId,
  });

  const insideMaps = useMemo(() => {
    const textureSwaps = query.data?.readyPlanConfigLike?.insideMapsTextureSwaps;
    return buildInsideMapsData(textureSwaps);
  }, [query.data]);

  if (query.loading) {
    return <div css={Css.w100.ar("5 / 3").h100.$}>Loading...</div>;
  }

  return (
    <div css={Css.w100.ar("5 / 3").h100.$}>
      <InsideMapsIFrameView
        iframeId={`configuration-rendering-page-insidemaps-iframe-${locationId}`}
        roomLocationId={locationId}
        // Setting this to true ensures we don't show the alternate camera toggle
        isPreview={true}
        insideMaps={insideMaps}
      />
    </div>
  );
}
